export default __webpack_public_path__ + "static/media/nap4.275484fd.png";